import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { RxCross1 } from "react-icons/rx";
import "./QuestionDetailModal.css"; // we'll use this for the pointer styling

export default function QuestionDetailModal({ item }) {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <div className="tw-relative tw-w-[30px]">
            <AiOutlineInfoCircle onClick={handleOpen} className="hover:tw-text-secondary tw-cursor-pointer" />
            {open && (
                <div
                    open={open}
                    className="tw-absolute tw-top-[28px] tw-right-0 sm:tw-left-[-203px] tw-z-10 tw-w-[280px] sm:tw-w-[400px] tw-rounded-md"
                >
                    <div className="tw-bg-white tw-p-4 sm:tw-p-5 tw-pr-8 sm:tw-pr-10 tw-relative tw-rounded-xl tw-shadow">
                        {/* Arrow (speech bubble pointer) */}
                        <div className="modal-pointer" />

                        {/* Close button */}
                        <button
                            onClick={handleClose}
                            className="tw-absolute tw-top-2 tw-right-2 tw-bg-background_color tw-p-[7px] tw-rounded-full tw-text-gray-500 hover:tw-text-gray-700"
                        >
                            <RxCross1 size={15} />
                        </button>

                        {/* Text */}
                        <p className="tw-mt-2 tw-text-sm ">{item.tooltip}</p>

                        {/* Video Section */}
                        {item.link && (
                            <div className="tw-mt-4 tw-rounded-lg tw-overflow-hidden">
                                <div className="tw-relative">
                                    <video className="tw-w-full tw-h-56 tw-rounded-lg" controls>
                                        <source src={`https://image.onmls.com${item.link}`} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            </div>
                        )}

                        {/* Link */}
                        {/* {item.link && (
                            <a
                                href={item.link}
                                className="tw-text-blue-600 tw-font-semibold tw-mt-3 tw-inline-block hover:tw-underline"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                See more details
                            </a>
                        )} */}
                    </div>
                </div>
            )}
        </div>
    );
}
